/**
 * Trigger a browser download of an in-memory object as a JSON file.
 *
 * Serializes `data`, wraps it in a Blob, and clicks a temporary anchor. The
 * object URL is revoked afterward to avoid leaking it.
 *
 * @param filename  Suggested download filename (e.g. "export.geojson").
 * @param data      Any JSON-serializable value.
 * @param mimeType  MIME type for the Blob (default "application/json"; use
 *                  "application/geo+json" for GeoJSON).
 */
export const downloadJson = (
  filename: string,
  data: unknown,
  mimeType = "application/json"
): void => {
  const blob = new Blob([JSON.stringify(data)], { type: mimeType });
  const url = URL.createObjectURL(blob);
  try {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    anchor.click();
  } finally {
    URL.revokeObjectURL(url);
  }
};
